import { AfterViewInit, ChangeDetectorRef, OnInit } from '@angular/core'
import { Component } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router'
import { Store, select } from '@ngrx/store'
import { Observable } from 'rxjs'
import { filter, map, take, tap } from 'rxjs/operators'
import { ActionService } from '../../modules/action-module'
import { EntityReference } from '../../modules/dto'
import { RootStoreState, UserProfileActions, UserProfileSelectors } from '../../root-store/root-index'
import { NotificationService } from '../../services/notification.service'

@Component({
  selector: 'jml-lib-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit, AfterViewInit {
  userId$: Observable<number>

  constructor(
    private store$: Store<RootStoreState.State>,
    private notificationService: NotificationService,
    private actionService: ActionService,
    private router: Router,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    // Since the dialog cleanup service will remove the action dialog when attempting to navigate we need to reopen it after each attempt
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => this.checkPasswordExpired())
  }

  ngAfterViewInit(): void {
    this.checkPasswordExpired()
    this.cdRef.detectChanges()
  }

  private checkPasswordExpired() {
    this.userId$ = this.store$.pipe(
      take(1),
      select((state) => UserProfileSelectors.selectUserProfileUser(state)),
      tap((user) => {
        if (!user?.user?.enforcePasswdChange) return

        this.actionService.performAction(
          'USER_PROFILE_NEW_PASSWORD',
          new EntityReference('UserProfile'),
          undefined,
          (success) => {
            if (success) this.store$.dispatch(UserProfileActions.changePwSucceeded())
          },
          false
        )
        this.notificationService.addWarnNotification('Das Passwort ist abgelaufen und muss geändert werden.')
      }),
      map((user) => user?.user?.id)
    )
  }
}
